import * as React from 'react';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';

import { TypographyItemName } from "../theme/types";

import { Title } from "./styled";























const BottomSheet = ({
  className = '',
  overflowHeight = 0,
  open = false,
  defaultOpen = false,
  onChange,
  onTransitionEnd,
  fullScreen = false,
  marginTop = 0,
  shadowTip = true,
  topShadow = true,
  overlay = true,
  scrollTopAtClose = true,
  swipeableViewsProps = {},
  rootStyle = {},
  bodyStyle = {},
  overlayStyle = {},
  title,
  titleStyle = {},
  titleTypography = TypographyItemName.Paragraph,
  children }) =>
{
  return /*#__PURE__*/(
    React.createElement(SwipeableBottomSheet, {
      className: className,
      overflowHeight: overflowHeight,
      open: open,
      defaultOpen: defaultOpen,
      onChange: onChange,
      onTransitionEnd: onTransitionEnd,
      fullScreen: fullScreen,
      marginTop: marginTop,
      shadowTip: shadowTip,
      topShadow: topShadow,
      overlay: overlay,
      scrollTopAtClose: scrollTopAtClose,
      style: rootStyle,
      bodyStyle: bodyStyle,
      overlayStyle: open && overlayStyle || {},
      swipeableViewsProps: swipeableViewsProps }, /*#__PURE__*/

    React.createElement(Title, { typography: titleTypography, minHeight: overflowHeight, style: titleStyle },
    title ? title : null),

    children));


};

export { BottomSheet };